import { Vue, Options } from 'vue-class-component'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { DateSelectArg, EventClickArg } from '@fullcalendar/core'

@Options({
  components: { FullCalendar }
})
export default class SimpleCalendar extends Vue {
  calendarOptions = {
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    selectable: true,
    editable: true,
    selectMirror: true,
    events: [
      { title: 'Meeting', start: new Date() },
      { title: 'Workshop', start: '2025-09-05' },
      { title: 'Tournament', start: '2025-09-10' }
    ],
    select: function (): void {
      alert('selected ')
    },
    eventClick: this.handleEventClick
  }

  handleDateSelect (info:DateSelectArg):void {
    console.log('✅ Date range selected:', info.startStr, info.endStr)
    const title = prompt('Enter Event Title:')
    if (title) {
      info.view.calendar.addEvent({
        title,
        start: info.startStr,
        end: info.endStr,
        allDay: info.allDay
      })
    }
    info.view.calendar.unselect()
  }

  handleEventClick (info: EventClickArg):void {
    alert(`Event: ${info.event.title}`)
  }
}
